import axiosInstance from "./axiosInstance";
import { ApproverResponse } from "../types/approverViewResponse";

export const getApproverView = async (
  plantId: string,
  approverId: string
): Promise<ApproverResponse[]> => {
  const params: any = { plantId, approverId };

  const response = await axiosInstance.get<ApproverResponse[]>(
    "/api/approver-view",
    {
      params,
    }
  );

  return response.data;
};
